<template>
    <div class="container main-container"><div class="align-items-center justify-content-center text-center">
      <hr class="my-1" />
      <div class="row justify-content-center contactIcons">
          <img src="../assets/location.png" alt />
          <a href="https://goo.gl/maps/y21qvw9AuD8VZYp28">Wartstrasse 32<br>8400 Winterthur</a>
      </div>
      <div class="row justify-content-center phoneIcons">
                    <img src="../assets/phoneIcon.png" alt />
                    <a href="tel:052 503 80 10">052 503 80 10</a>
      </div>
      <div class="row justify-content-center hourIcons">
                    <img src="../assets/hours.png" alt />
                    <span>Täglich von 10:00 bis 23:00 offen</span>
      </div>
      <div class="row justify-content-center">
                    <h4>Wir freuen uns auf dein Besuch!</h4>
</div>
                  <div class="row justify-content-center">
                    <h3 class="display-5">Folge uns auf folgenden Platformen</h3>
</div>
      <div class="row justify-content-center">
        <a href="https://www.facebook.com/fabiimbiss/">
          <img id="footerImg" src="../assets/facebookIcon.png" alt />
        </a>
        <a href="https://www.instagram.com/fabiimbiss/?igshid=tjrvc6qhgakf">
          <img id="footerImg" src="../assets/instaIcon.png" alt />
        </a>
      </div>
    </div></div>
</template>
<script>
export default {
    name: "Contact"
}
</script>
<style scoped>
.main-container{
  height: 100%;
  background-image: url(../assets/wintiWappen.png);
  background-color: #191919;
  color: whitesmoke;
}
h1, h3, h5{
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}
.my-3{
    color: white;
}
.contactIcons{
  margin-top: 50px;
}
.phoneIcons{
  margin-top: 30px;
}
.phoneIcons > a{
  margin-left: 15px;
}
.hourIcons{
  margin-top: 30px;
}
.display-5{
    margin-top: 71px;
}
h4{
      margin-top: 60px;
}
a, span{
  color: white;
}
@media only screen 
    and (max-width : 600px) {
    h3, h4{
  font-size: 22px;
}
.contactIcons{
  margin-top: 25px;
}
.phoneIcons{
  margin-top: 15px;
}
.hourIcons{
  margin-top: 15px;
}
.display-5{
    margin-top: 70px;
}
h4{
      margin-top: 39px;
}
#footerImg{
  width: 75%;
}
     }
     @media only screen 
    and ( max-width : 800px)
    and ( min-width : 601px) {
   h3, h4{
  font-size: 24px;
}
.contactIcons{
  margin-top: 25px;
}
.phoneIcons{
  margin-top: 15px;
}
.hourIcons{
  margin-top: 15px;
}
.display-5{
    margin-top: 80px;
}
h4{
      margin-top: 45px;
}
     }
</style>